import React, { type PropsWithChildren, useContext } from "react";
import { MySelectionContext, MySelectionBackButton } from "components/Tables/MySelection";
import { ButtonText, ButtonSecondary } from "components/Atoms/Button";
import { FilterContext } from "./FilterContext";

interface Props {
  isLoading?: boolean
  compact?: boolean
}

const FilterHeader = (props: PropsWithChildren<Props>) => {
  const { isDefault, revertToDefault, renderSelection } = useContext(FilterContext);
  const mySelection = useContext(MySelectionContext);

  if (props.isLoading) {
    return <div className={`${props.compact ? "s1_panel selectiontool" : "s1_panel selectiontool grow1 flex-column"}`}>
      <div className="selectiontool-header">
        {props.children}
      </div>
      <div className="grow1">&nbsp;</div>
    </div>;
  }

  if (mySelection.enabled && mySelection.showOnlyMySelection) {
    return <div className="s1_panel selectiontool grow1 flex-column">
      <div className="selectiontool-header selectiontool-header-mySelection">
        <MySelectionBackButton />
      </div>
      <div className="filterBatchActions grow1 flex gap-larger">
        {mySelection.batchActions.map((action, index) => (
          <ButtonSecondary
            key={index}
            label={action.label}
            onClick={() => { mySelection.toggleBatchAction(index); }}
          />
        ))}
        <ButtonText
          label={RESX.GeneralLabels.ClearSelection}
          onClick={() => { mySelection.clearSelection(); }}
        />
      </div>
    </div>;
  }

  return <div className={`${props.compact ? "s1_panel selectiontool" : "s1_panel selectiontool grow1 flex-column"}`}>
    <div className="selectiontool-header">
      {props.children}
    </div>

    <div className="appliedfilter-container grow1">
      <div className="appliedFilters">
        {renderSelection()}
      </div>

      {!isDefault && <div
        tabIndex={0}
        className="margin-top-large flex"
        onClick={() => { revertToDefault(); }}
        style={{ cursor: "pointer", display: "inline-block" }}
      >
        <div className="s1_selectiontool_revertToDefault" title={RESX.SelectionManager.ResetFilters}>
          <i className="icon-reply"></i>
        </div>
      </div>}
    </div>
  </div>;
};

const FilterButtons = (props: React.PropsWithChildren<unknown>) => {
  return <>
    {props.children}
  </>;
};

export default {
  Filters: FilterHeader,
  Buttons: FilterButtons
};
